import { useEffect, useState } from "react"
import { HiArrowTrendingUp } from "react-icons/hi2";
import Select from 'react-select';
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProgrammesData } from "../redux/slice/allProgrammesPage";
import Search from "../utils/search";
import { Link } from "react-router-dom";
import axios from "axios";
import { apis } from "../api/apiUrl";
const DropdownSearch = () => {
    const [open, setOpen] = useState(false)
    const [data, setData] = useState([])
    const state = useSelector(state => state.homepage)
    const programmes = useSelector(state => state.allProgrammes)
    const dispatch = useDispatch()
    const [selectedCollege, setSelectedCollege] = useState(null)
    const [selectedLevel, setSelectedLevel] = useState(null)


  

    useEffect(() => {
        if (data?.length > 0) {
            setOpen(true)
        }
        else {
            setOpen(false)
        }
    }, [data])

    useEffect(() => {
        dispatch(fetchAllProgrammesData("/all-programmes"))
    }, [dispatch])

    // const faculty = state?.data?.properties.faculty.map(fac => ({ label: fac, value: fac }))
    const levelofStudy = state?.data?.properties.levelOfStudy.map((fac,i) => ({ label: fac, value: i+1 }))
    // const degs = state?.data?.properties.trendingSearch.map(deg => ({ text: deg, icon: <HiArrowTrendingUp size={25} /> }))


    console.log(programmes)
    const faculty = programmes?.data?.properties?.colleges?.items?.map((college) => ({
        label: college?.content?.properties?.collegeName?.name,
        value: college?.content?.properties?.collegeName?.id,


    }))


    const saveCourse = async (ratingId) => {
        try {
           await axios.post(`${apis.uniten_api}/selectCourse`, {
                ratingId: ratingId
            })
        } catch (error) {
            console.log(error)
        }
    }




    return (
        // <div className=" w-full  bg-white shadow-md 2xl:border rounded-md p-2">
        //     <div className="grid  grid-cols-1 gap-3 md:gap-0 md:grid-cols-3   w-full ">

        //         <div className="w-full h-8 flex items-center justify-between" >
        //             <span className="ml-5">Faculty</span>
        //             <FiChevronDown size={25} />
        //         </div>
        //         <div className="w-full h-8 flex items-center justify-between">
        //             <span className="ml-5">Level of Study</span>
        //             <FiChevronDown size={25} />
        //         </div>

        //         <div className="flex items-center w-full">
        //             <input type="text" placeholder="Search" className="outline-none border-0 w-full px-4" onFocus={handleOpen} onBlur={() => setOpen(false)} />
        //             <MdSearch className="2xl:w-8 2xl:h-8" />
        //         </div>

        //     </div>
        //     <motion.div
        //         initial={{ height: 0, opacity: 0 }}
        //         animate={open ? { height: "fit-content", opacity: 1 } : { height: 0, opacity: 0 }}
        //         transition={{ duration: .7, ease: 'easeInOut' }}
        //         className={`w-full flex  flex-col z-40 `}>
        //         <motion.div
        //             initial={{ opacity: 0 }}
        //             animate={open ? { opacity: 1 } : { opacity: 0 }}
        //             transition={{ duration: .7, ease: 'easeInOut' }}
        //             className={`${open? "flex" : "hidden"} flex-col w-full h-full`}>
        //             {
        //                 degs.map((deg, index) => (
        //                     <div key={index} className="flex w-full items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer">
        //                         {deg.icon}
        //                         <span>{deg.text}</span>
        //                     </div>
        //                 ))
        //             }
        //         </motion.div>
        //     </motion.div>
        // </div>

        <div className=" w-full  bg-white shadow-md 2xl:border rounded-md p-2">
            <div className="grid  grid-cols-1 gap-3 md:gap-0 md:grid-cols-3   w-full ">
                <Select
                    options={faculty}
                    isClearable
                    
                    onChange={(e) => { setSelectedCollege(e?.value) }}

                    styles={{
                        control: (provided) => ({
                            ...provided,
                            border: "0",
                            outline: "none",
                            boxShadow: "none",
                        }),
                    }}
                    className={`border-0 outline-none focus:outline-none  font-bold`} />
                <Select options={levelofStudy}
                    isClearable
                    onChange={(e) => setSelectedLevel(e?.value)}
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            border: "0",
                            outline: "none",
                            boxShadow: "none",
                        }),
                    }}
                    className={`border-0 outline-none focus:outline-none  font-bold`} />
                <div className="flex items-center w-full"  >
                    <Search handleSetData={setData} faculty={selectedCollege} level={selectedLevel} />

                </div>
            </div>
            {
                data?.length > 0 &&
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={open ? { height: "fit-content", opacity: 1 } : { height: 0, opacity: 0 }}
                    transition={{ duration: .7, ease: 'easeInOut' }}
                    className={`w-full flex  flex-col z-40 `}>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={open ? { opacity: 1 } : { opacity: 0 }}
                        transition={{ duration: .7, ease: 'easeInOut', delay: .5 }}
                        className={`${open ? "flex" : "hidden"} flex-col w-full h-full max-h-[20rem] overflow-y-auto`}>
                        {
                            data?.map((deg, index) => (
                                <Link onClick={(e)=>{
                                    e.stopPropagation()
                                    saveCourse(deg.ratingId)
                                }}  to={`/all-programmes/${deg?.path?.split('/')[2]}/${deg?.path?.split('/')[3]}`} key={index} className="flex w-full items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer">
                                    {<HiArrowTrendingUp size={25} />}
                                    <span>{deg.courseName}</span>
                                </Link>
                            ))
                        }
                    </motion.div>
                </motion.div>}
        </div>


    )
}

export default DropdownSearch